var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import Div100vh from 'react-div-100vh';
import styled from 'styled-components';
import Simple from '../components/tooltips/simple';
import { TooltipContext } from '../context/tooltip';
import { TooltipPosition, TooltipType } from '../types/tooltips';
export default function GlobalTooltip() {
    var tooltipProps = useContext(TooltipContext).tooltipProps;
    return (_jsx(Container, { visible: Boolean(tooltipProps), children: tooltipProps && (_jsxs(TooltipContainer, { mobilePosition: tooltipProps.common.mobilePosition, position: tooltipProps.common.position, rect: tooltipProps.common.rect, children: [_jsx("div", { className: "main-container", children: _jsx(_Fragment, { children: tooltipProps.custom.type === TooltipType.SIMPLE && _jsx(Simple, { message: tooltipProps.custom.message }) }) }), _jsx("div", { className: "decorator" })] })) }));
}
var Container = styled(Div100vh)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  left: 0;\n  position: fixed;\n  top: 0;\n  opacity: ", ";\n  pointer-events: none;\n  transition: opacity 200ms ease-in-out;\n  width: 100vw;\n  z-index: 100;\n"], ["\n  left: 0;\n  position: fixed;\n  top: 0;\n  opacity: ", ";\n  pointer-events: none;\n  transition: opacity 200ms ease-in-out;\n  width: 100vw;\n  z-index: 100;\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? '1' : '0');
});
var TooltipContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: ", ";\n  bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n  justify-content: ", ";\n  left: ", ";\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  width: 400px;\n\n  @media screen and (max-width: 824px) {\n    align-items: ", ";\n    bottom: ", ";\n    justify-content: ", ";\n    left: ", ";\n    right: ", ";\n    top: ", ";\n  }\n\n  .main-container {\n    background-color: ", ";\n    border-radius: 6px;\n    padding: 12px;\n\n    .message {\n      font-size: 12px;\n      font-weight: 400;\n      max-width: 200px;\n      text-align: left;\n    }\n  }\n\n  .decorator {\n    background-color: ", ";\n    bottom: ", ";\n    height: 12px;\n    left: ", ";\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    transform: rotate(45deg);\n    width: 12px;\n\n    @media screen and (max-width: 824px) {\n      bottom: ", ";\n      left: ", ";\n      right: ", ";\n      top: ", ";\n    }\n  }\n"], ["\n  align-items: ", ";\n  bottom: ", ";\n  display: flex;\n  flex-direction: column;\n  height: 400px;\n  justify-content: ", ";\n  left: ", ";\n  position: absolute;\n  right: ", ";\n  top: ", ";\n  width: 400px;\n\n  @media screen and (max-width: 824px) {\n    align-items: ", ";\n    bottom: ", ";\n    justify-content: ", ";\n    left: ", ";\n    right: ", ";\n    top: ", ";\n  }\n\n  .main-container {\n    background-color: ", ";\n    border-radius: 6px;\n    padding: 12px;\n\n    .message {\n      font-size: 12px;\n      font-weight: 400;\n      max-width: 200px;\n      text-align: left;\n    }\n  }\n\n  .decorator {\n    background-color: ", ";\n    bottom: ", ";\n    height: 12px;\n    left: ", ";\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    transform: rotate(45deg);\n    width: 12px;\n\n    @media screen and (max-width: 824px) {\n      bottom: ", ";\n      left: ", ";\n      right: ", ";\n      top: ", ";\n    }\n  }\n"])), function (_a) {
    var position = _a.position;
    if (position === TooltipPosition.LEFT)
        return 'flex-end';
    if (position === TooltipPosition.RIGHT)
        return "flex-start";
    return 'center';
}, function (_a) {
    var rect = _a.rect, position = _a.position;
    return (position === TooltipPosition.TOP ? "calc(100% - ".concat(rect.top, "px + 16px)") : 'auto');
}, function (_a) {
    var position = _a.position;
    if (position === TooltipPosition.TOP)
        return 'flex-end';
    if (position === TooltipPosition.BOTTOM)
        return "flex-start";
    return 'center';
}, function (_a) {
    var rect = _a.rect, position = _a.position;
    if (position === TooltipPosition.LEFT)
        return 'auto';
    if (position === TooltipPosition.RIGHT)
        return "".concat(rect.left + rect.width + 16, "px");
    return "".concat(rect.left + (rect.width - 400) / 2, "px");
}, function (_a) {
    var rect = _a.rect, position = _a.position;
    return (position === TooltipPosition.LEFT ? "calc(100% - ".concat(rect.left, "px + 16px)") : 'auto');
}, function (_a) {
    var rect = _a.rect, position = _a.position;
    if (position === TooltipPosition.TOP)
        return 'auto';
    if (position === TooltipPosition.BOTTOM)
        return "".concat(rect.top + rect.height + 16, "px");
    return "".concat(rect.top + (rect.height - 400) / 2, "px");
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.LEFT)
        return 'flex-end';
    if (appliedPosition === TooltipPosition.RIGHT)
        return "flex-start";
    return 'center';
}, function (_a) {
    var rect = _a.rect, mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    return appliedPosition === TooltipPosition.TOP ? "calc(100% - ".concat(rect.top, "px + 16px)") : 'auto';
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.TOP)
        return 'flex-end';
    if (appliedPosition === TooltipPosition.BOTTOM)
        return "flex-start";
    return 'center';
}, function (_a) {
    var rect = _a.rect, mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.LEFT)
        return 'auto';
    if (appliedPosition === TooltipPosition.RIGHT)
        return "".concat(rect.left + rect.width + 16, "px");
    return "".concat(rect.left + (rect.width - 400) / 2, "px");
}, function (_a) {
    var rect = _a.rect, mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    return appliedPosition === TooltipPosition.LEFT ? "calc(100% - ".concat(rect.left, "px + 16px)") : 'auto';
}, function (_a) {
    var rect = _a.rect, mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.TOP)
        return 'auto';
    if (appliedPosition === TooltipPosition.BOTTOM)
        return "".concat(rect.top + rect.height + 16, "px");
    return "".concat(rect.top + (rect.height - 400) / 2, "px");
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.purple;
}, function (_a) {
    var position = _a.position;
    return (position === TooltipPosition.TOP ? '-6px' : 'auto');
}, function (_a) {
    var position = _a.position;
    if (position === TooltipPosition.LEFT)
        return 'auto';
    if (position === TooltipPosition.RIGHT)
        return '-6px';
    return 'calc(50% - 6px)';
}, function (_a) {
    var position = _a.position;
    return (position === TooltipPosition.LEFT ? '-6px' : 'auto');
}, function (_a) {
    var position = _a.position;
    if (position === TooltipPosition.TOP)
        return 'auto';
    if (position === TooltipPosition.BOTTOM)
        return '-6px';
    return 'calc(50% - 6px)';
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    return appliedPosition === TooltipPosition.TOP ? '-6px' : 'auto';
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.LEFT)
        return 'auto';
    if (appliedPosition === TooltipPosition.RIGHT)
        return '-6px';
    return 'calc(50% - 6px)';
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    return appliedPosition === TooltipPosition.LEFT ? '-6px' : 'auto';
}, function (_a) {
    var mobilePosition = _a.mobilePosition, position = _a.position;
    var appliedPosition = mobilePosition || position;
    if (appliedPosition === TooltipPosition.TOP)
        return 'auto';
    if (appliedPosition === TooltipPosition.BOTTOM)
        return '-6px';
    return 'calc(50% - 6px)';
});
var templateObject_1, templateObject_2;
